'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('sharelink', {
        url: '/sharelink',
        template: '<sharelink></sharelink>'
    });
}



// WEBPACK FOOTER //
// ./client/app/sharelink/sharelink.routes.js